import L from 'leaflet';
import * as React from 'react';

/**
 * Render a map element to the given ref and return a reference to the map
 * @param mapRef
 * @param options
 * @returns
 */
export function useMapElement(
  mapRef: React.MutableRefObject<HTMLElement | null>,
  options: L.MapOptions,
): L.Map | null {
  const [map, setMap] = React.useState<L.Map | null>(null);

  React.useEffect(() => {
    if (mapRef.current !== null && map === null) {
      const instance = L.map(mapRef.current, options);
      if (options.center != null && options.zoom != null) {
        instance.setView(options.center, options.zoom);
      }

      setMap(instance);
    }
  }, [mapRef, map, options]);

  return map;
}
